export const TIMINGS = ["Matin", "Midi", "Soir", "Avant entraînement", "Après entraînement", "Avant coucher"];

export const TIMING_COLORS = {
  Matin: "bg-amber-50 text-amber-700 border-amber-100",
  Midi: "bg-orange-50 text-orange-700 border-orange-100",
  Soir: "bg-indigo-50 text-indigo-700 border-indigo-100",
  "Avant entraînement": "bg-red-50 text-red-700 border-red-100",
  "Après entraînement": "bg-green-50 text-green-700 border-green-100",
  "Avant coucher": "bg-purple-50 text-purple-700 border-purple-100",
};

const foldText = (value) => (value || "")
  .toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "");

export const detectTimingFromText = (text) => {
  const folded = foldText(text);
  if (/avant.*(entrain|workout|seance|sport)/.test(folded) || /pre[\s-]?workout/.test(folded)) {
    return "Avant entraînement";
  }
  if (/apres.*(entrain|workout|seance|sport)|post[\s-]?workout|apres la seance/.test(folded)) {
    return "Après entraînement";
  }
  if (/avant.*coucher|au coucher|le coucher/.test(folded)) {
    return "Avant coucher";
  }
  if (/au matin|le matin|matin|petit[\s-]?dej|reveil/.test(folded)) {
    return "Matin";
  }
  if (/midi|dejeuner/.test(folded)) {
    return "Midi";
  }
  if (/soir|diner|souper/.test(folded)) {
    return "Soir";
  }
  return null;
};

export const normalizePlanTiming = (timing, notes = "") => {
  const raw = (timing || "").trim();
  if (TIMINGS.includes(raw)) {
    if (raw === "Matin" && notes) {
      const fromNotes = detectTimingFromText(notes);
      if (fromNotes && fromNotes !== "Matin") return fromNotes;
    }
    return raw;
  }

  const fromCombined = detectTimingFromText(`${raw} ${notes}`);
  if (fromCombined) return fromCombined;

  return "Matin";
};

export const normalizePlanItem = (item) => ({
  name: item.name || "",
  dosage: item.dosage || "1 dose",
  timing: normalizePlanTiming(item.timing, item.notes),
  notes: item.notes || "",
  supplement_id: item.supplement_id || null,
});

export const normalizePlan = (plan) => ({
  ...plan,
  items: (plan.items || []).map((item) => ({
    ...item,
    timing: normalizePlanTiming(item.timing, item.notes),
  })),
});